import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

import {
  IPermission,
  IPermissionDoc,
} from 'src/pages/settings/components/permission-group/components/modal-form/modal-form.interfaces';
import { IHookCallbacks } from 'src/hooks/common.hooks.interfaces';

import { GET_PERMISSIONS_GROUPS } from './get-permissions-groups.hook';

export const UPDATE_PERMISSION_GROUP = gql`
  mutation updatePermissionsGroup(
    $permissionGroupId: String!
    $payload: CreatePermissionsGroupInput!
  ) {
    updatePermissionsGroup(permissionGroupId: $permissionGroupId, payload: $payload) {
      _id
    }
  }
`;

export const useUpdatePermissionGroup = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation('settings');

  const [updatePermissionGroup] = useMutation(UPDATE_PERMISSION_GROUP, {
    refetchQueries: [GET_PERMISSIONS_GROUPS],
    onCompleted: () => {
      onSuccess();
      showNotification({
        type: NOTIFICATION_TYPE.success,
        isIcon: false,
        message: t('permissionGroupSettings.notifications.permissionGroupUpdated'),
      });
    },
    onError: error =>
      showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('userProfileSettings.error.title'),
        description: t('userProfileSettings.error.subTitle'),
      }),
  });

  return (permissionGroupId: string, { name, permissions }: IPermissionDoc) =>
    updatePermissionGroup({
      variables: {
        permissionGroupId,
        payload: {
          name,
          permissions: permissions.map(({ permission, rule }: IPermission) => ({
            rule,
            permission,
          })),
        },
      },
    });
};
